import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface GetBranchesApiParameter extends ApiParameter {}

// Ported from WhiteCap Canada. National Ladder has no province level, so the API returns a flat branch list
// and recipient emails are not sent to the browser.
export interface BranchDto {
    name: string;
    number: number;
}

export interface BranchModel {
    id: string;
    name: string;
}

export function getBranches(parameter: GetBranchesApiParameter) {
    return get<BranchDto[]>("api/v1/getBranchData", parameter).then(response =>
        response.map(b => ({
            id: b.number.toString(),
            name: b.name,
        })),
    );
}
